import type { ModalProps as MuiModalProps } from '@mui/material';
import { Modal as MuiModal } from '@mui/material';
import { useTracking } from '@packages/tracking';
import type {
  GTMEventGlycerinDisplayOverlay,
  GlycerinDisplayBasePayload,
} from '@packages/tracking';
import { useEffect, type FC } from 'react';

type ModalProps = MuiModalProps & { displayTrackingProps?: GlycerinDisplayBasePayload };

// If you need other prop, please add it in the object. otherwise
/** Modal. Based on MUI Fade: https://mui.com/material-ui/react-modal */
export const Modal: FC<ModalProps> = (props) => {
  const { children, displayTrackingProps, open, title, ...rest } = props;
  const { category, custom, detail, label, placement, variantIds } = displayTrackingProps ?? {};

  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (open) {
      dispatchGTMEvent<GTMEventGlycerinDisplayOverlay>({
        event: 'DisplayOverlay',
        DisplayOverlayData: {
          category: category ?? 'display-overlay',
          custom,
          detail,
          label: label ?? title,
          placement,
          variantIds,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <MuiModal data-testid="modal" open={open} title={title} {...rest}>
      {children}
    </MuiModal>
  );
};
